export class PaginationUtils {
  static generatePageNumbers(
    currentPage: number,
    totalPages: number,
    maxVisiblePages: number = 2
  ): (number | 'ellipsis')[] {
    if (totalPages <= 1) {
      return [1];
    }

    const pages: (number | 'ellipsis')[] = [];

    let startPage = currentPage - maxVisiblePages;
    let endPage = currentPage + maxVisiblePages;

    if (startPage < 2) {
      endPage = Math.min(endPage + (2 - startPage), totalPages - 1);
      startPage = 2;
    }

    if (endPage > totalPages - 1) {
      startPage = Math.max(startPage - (endPage - (totalPages - 1)), 2);
      endPage = totalPages - 1;
    }

    pages.push(1);

    if (startPage > 2) {
      pages.push('ellipsis');
    }

    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
    }

    if (endPage < totalPages - 1) {
      pages.push('ellipsis');
    }

    pages.push(totalPages);

    return pages;
  }

  static isValidPage(page: number, totalPages: number): boolean {
    return page >= 1 && page <= totalPages && Number.isInteger(page);
  }
}
